<template>
  <transition name="sel-bar">
    <div v-if="count > 0" class="sel-bar">
      <span class="sel-bar__count">{{ count }} seleccionada{{ count === 1 ? '' : 's' }}</span>
      <button class="sel-bar__btn" :disabled="loading" @click="$emit('descargar')">
        <i :class="loading ? 'fa-solid fa-spinner fa-spin' : 'fa-solid fa-file-pdf'"></i>
        {{ loading ? 'Descargando…' : 'Descargar PDFs' }}
      </button>
      <button class="sel-bar__close" :disabled="loading" title="Quitar selección" @click="$emit('limpiar')">
        <i class="fa-solid fa-xmark"></i>
      </button>
    </div>
  </transition>
</template>

<script>
// Banner flotante para acciones sobre filas seleccionadas (gastos proveedor, facturas)
export default {
  name: 'SeleccionPdfBar',
  props: {
    count: { type: Number, default: 0 },
    loading: { type: Boolean, default: false },
  },
}
</script>

<style scoped>
.sel-bar {
  position: fixed;
  bottom: 24px;
  left: 50%;
  transform: translateX(-50%);
  z-index: 1030;
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 8px 8px 8px 18px;
  background: #1E293B;
  color: #fff;
  border-radius: 999px;
  box-shadow: 0 10px 30px rgba(15, 23, 42, 0.3);
  font-size: 13px;
  white-space: nowrap;
}

.sel-bar__count {
  font-weight: 600;
}

.sel-bar__btn {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  height: 34px;
  padding: 0 14px;
  border: 0;
  border-radius: 999px;
  background: #7367f0;
  color: #fff;
  font-weight: 600;
  cursor: pointer;
  transition: background 0.15s;
}

.sel-bar__btn:hover:not(:disabled) {
  background: #5e50ee;
}

.sel-bar__close {
  width: 34px;
  height: 34px;
  border: 0;
  border-radius: 50%;
  background: transparent;
  color: #94A3B8;
  cursor: pointer;
  transition: all 0.15s;
}

.sel-bar__close:hover:not(:disabled) {
  background: rgba(255, 255, 255, 0.1);
  color: #fff;
}

.sel-bar button:disabled {
  opacity: 0.7;
  cursor: default;
}

/* Modo noche: gris de la app con borde */
.dark-layout .sel-bar {
  background: #2e2e2e;
  border: 1px solid #3b3b3b;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.5);
}

.sel-bar-enter-active,
.sel-bar-leave-active {
  transition: opacity 0.2s, transform 0.2s;
}

.sel-bar-enter,
.sel-bar-leave-to {
  opacity: 0;
  transform: translate(-50%, 16px);
}
</style>
